export default "__VITE_ASSET__LFEWJmQw__"